/* eslint-disable no-restricted-syntax, no-await-in-loop, no-continue, no-promise-executor-return, consistent-return, no-void, max-len, class-methods-use-this, no-underscore-dangle, no-undef, no-plusplus, prefer-destructuring, no-param-reassign, no-use-before-define, no-nested-ternary */
// Ported from newdtrader (packages/core/src/_common/base/dfunded); kept in its
// original style so fixes can be carried across the two copies.
/**
 * Accumulator stats. Deriv sends the last 100 tick counts only in a proposal
 * stream's first message, then just the latest count. A parked stream that is
 * picked up again would hand the app one number, so the history is kept up to
 * date with the stream and given back in full. (The DFunded server does the
 * same for the streams it shares between traders.)
 */

/** The history after `message`, oldest count first, as Deriv sends it. */
const mergeTickStats = (previous, message) => {
    const details = message && message.proposal && message.proposal.contract_details;
    const incoming = details && details.ticks_stayed_in;
    const epoch = Number(details && details.last_tick_epoch);
    if (!Array.isArray(incoming) || !incoming.length || !epoch) return previous;
    if (incoming.length > 1 || !previous || !previous.ticks.length) return { ticks: [...incoming], epoch };
    const latest = incoming[0];
    const last = previous.ticks[previous.ticks.length - 1];
    // A higher count is the same counter going up (Deriv sometimes repeats a
    // tick's epoch); a count no higher, on a later tick, is a new counter (the
    // barrier was crossed). Anything else is a repeat.
    if (latest > last && epoch >= previous.epoch) return { ticks: [...previous.ticks.slice(0, -1), latest], epoch };
    if (epoch > previous.epoch) return { ticks: [...previous.ticks.slice(1), latest], epoch };
    return previous;
};

/** `message` carrying the whole history instead of only the latest count. */
const withTickStats = (message, stats) => {
    if (!stats || !message || !message.proposal || !message.proposal.contract_details) return message;
    return {
        ...message,
        proposal: {
            ...message.proposal,
            contract_details: {
                ...message.proposal.contract_details,
                ticks_stayed_in: stats.ticks,
                last_tick_epoch: stats.epoch,
            },
        },
    };
};

module.exports = { mergeTickStats, withTickStats };
